module.exports = __webpack_public_path__ + "img/active.242b61a3.png";